import { Component, forwardRef } from "react";
import { createPortal } from "react-dom";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { exhibitionId, orderStatusActionId, serviceTypeId, toastError, toastSuccess, DOC_BASE_URL } from "../../../utils/constants";
import { getVendorExhibitionList_action, markOrderSeen_action } from '../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action'
import { raiseManualForm_action, markManualFormInvoicePaid_action } from '../../../actions/vendor_module_action/vendor_order_action'
import moment from "moment";
import Modal from "react-modal";
import Resizer from "react-image-file-resizer";
import ImageCapture from "../../../utils/ImageCapture";

//Manual Page 
import FasciaForm from "../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";


const styles = {
  width: '100%',
};

class VendorExhibitionList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      vendorRegistrationList: [],
      vendorServiceList: [],
      currentPage: 1,
      ExhibitionID: "",
      exhibitionList: [],
      ServiceID: "",
      StatusID: "",
      serviceTypeList: [],
      orderStatusList: [],
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: "", FilePath: "", FileType: "" },
      showVideoModal: false,
      dashboardData: null,
      showCameraModal: false,
      //modal
      isManualFormModalOpen: false,
      selectedServiceName: null,
      isCompanyModalOpen: false,
      selectedCompanyData: null,
    };
    this.updateItem = this.updateItem.bind(this)
    this.onViewClick = this.onViewClick.bind(this)
    this.pollingTimer = null
  }

  async componentDidMount() {
    this.setState({ isLoading: true })

    await Promise.all([
      this.getFillList(exhibitionId, '', '', '', '', ''),
      this.getFillList(serviceTypeId, '', '', '', '', ''),
      this.getFillList(orderStatusActionId, '', '', '', '', '')
    ])

    // Auto-set exhibition for vendor role (RoleID 7)
    const loginData = JSON.parse(sessionStorage.getItem('loginDataSS'));
    const filterStatusID = sessionStorage.getItem('filterStatusID');
    const filterServiceName = sessionStorage.getItem('filterServiceName');

    if (loginData && loginData.RoleID === 7) {
      const exhibitionID = sessionStorage.getItem('sessionExhibitionID');
      if (exhibitionID) {
        this.setState({
          ExhibitionID: exhibitionID,
          StatusID: filterStatusID || ''
        }, async () => {
          if (filterServiceName) {
            setTimeout(async () => {
              const matchedService = this.state.serviceTypeList.find(s => s.Name === filterServiceName);
              if (matchedService) {
                this.setState({ ServiceID: matchedService.ServiceID }, async () => {
                  await this.getVendorExhibitionList();
                });
              } else {
                await this.getVendorExhibitionList();
              }
            }, 500);
          } else {
            await this.getVendorExhibitionList();
          }
          sessionStorage.removeItem('filterStatusID');
          sessionStorage.removeItem('filterServiceName');
        });
      } else {
        this.setState({
          StatusID: filterStatusID || ''
        }, async () => {
          if (filterServiceName) {
            setTimeout(async () => {
              const matchedService = this.state.serviceTypeList.find(s => s.Name === filterServiceName);
              if (matchedService) {
                this.setState({ ServiceID: matchedService.ServiceID }, async () => {
                  await this.getVendorExhibitionList();
                });
              } else {
                await this.getVendorExhibitionList();
              }
            }, 500);
          } else {
            await this.getVendorExhibitionList();
          }
          sessionStorage.removeItem('filterStatusID');
          sessionStorage.removeItem('filterServiceName');
        });
      }
    } else {
      this.setState({
        StatusID: filterStatusID || ''
      }, async () => {
        if (filterServiceName) {
          setTimeout(async () => {
            const matchedService = this.state.serviceTypeList.find(s => s.Name === filterServiceName);
            if (matchedService) {
              this.setState({ ServiceID: matchedService.ServiceID }, async () => {
                await this.getVendorExhibitionList();
              });
            } else {
              await this.getVendorExhibitionList();
            }
          }, 500);
        } else {
          await this.getVendorExhibitionList();
        }
        sessionStorage.removeItem('filterStatusID');
        sessionStorage.removeItem('filterServiceName');
      });
    }

    this.startPolling()
  }

  componentWillUnmount() {
    this.stopPolling()
  }

  // Refresh the list every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling()
    this.pollingTimer = setInterval(() => {
      // Skip the refresh while the user is busy in a modal so their work isn't disturbed
      const isAnyModalOpen = this.state.showRaiseModal || this.state.showMarkPaidModal ||
        this.state.showCameraModal || this.state.isManualFormModalOpen ||
        this.state.isCompanyModalOpen || this.state.showVideoModal
      if (isAnyModalOpen || document.hidden) {
        return
      }
      this.getVendorExhibitionList(true)
    }, 15000)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  openModal(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      return <FreightForward />;
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }
  handleManualFormModal = (serviceName, ExhRegistrationID) => {
    ;
    sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      selectedServiceName: serviceName,
    });
  };

  handleCompanyModal = (data) => {
    sessionStorage.setItem("ExhRegistrationIDSS", data.ExhRegistrationID);
    this.setState({
      isCompanyModalOpen: true,
      selectedCompanyData: data,
    });
  };

  // get fill List dropdown  
  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
    try {
      const data = await this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
      if (data.error != 1) {
        if (actionID === exhibitionId) {
          this.setState({ exhibitionList: data.data })
        }
        if (actionID === serviceTypeId) {
          console.log("voucher type data", data.data)
          this.setState({ serviceTypeList: data.data })
        }
        if (actionID === orderStatusActionId) {
          this.setState({ orderStatusList: data.data })
        }
      } else {
        toastError(data.msg)
      }
    } catch (e) {
      console.log(e);
    }
  }


  // Update Current Page
  updateItem(item) {
    const { vendorRegistrationList } = this.state
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage)
  }

  // isSilent = background poll: keep the loader hidden and don't toast transient errors
  async getVendorExhibitionList(isSilent = false) {
    const { ExhibitionID, ServiceID, StatusID } = this.state
    const filterStatusID = sessionStorage.getItem('filterStatusID')
    if (!isSilent) {
      this.setState({ isLoading: true })
    }
    try {
      const data = await this.props.getVendorExhibitionList_action(ExhibitionID, ServiceID, StatusID)
      if (data.error != 1) {
        if (!isSilent) console.log('API Response data.data:', data.data);
        await new Promise((resolve) => {
          this.setState({
            vendorRegistrationList: data.data.exhibitorList,
            vendorServiceList: data.data.serviceList,
            dashboardData: data.data
          }, () => {
            if (!isSilent) console.log('Updated dashboardData:', this.state.dashboardData);
            resolve()
          })
        })

        if (filterStatusID === '3' && data.data.exhibitorList?.length > 0) {
          const exhibitionID = sessionStorage.getItem('sessionExhibitionID')
          const vendorID = sessionStorage.getItem('AccountIDSS')
          const orderDetails = data.data.exhibitorList.map(item => ({
            ExhibitionID: exhibitionID,
            VendorID: vendorID,
            ExhRegistrationID: item.ExhRegistrationID,
            ServiceID: item.ServiceID
          }))
          await this.props.markOrderSeen_action(orderDetails)
        }
        this.setState({ isLoading: false })
      } else {
        this.setState({ isLoading: false })
        if (!isSilent) toastError(data.msg)
      }
    } catch (err) {
      console.log(err)
      this.setState({ isLoading: false })
    }
  }

  clearValue() {
    const loginData = JSON.parse(sessionStorage.getItem('loginDataSS'));
    if (loginData && (loginData.RoleID === 7 || loginData.RoleID === 17)) {
      // For vendors, don't clear ExhibitionID, only ServiceID and StatusID
      this.setState({ ServiceID: '', StatusID: '' });
    } else {
      this.setState({ ExhibitionID: '', ServiceID: '', StatusID: '' });
    }

    setTimeout(() => {
      this.getVendorExhibitionList()
    }, 100);
  }

  onViewClick(exhRegId, ServiceID) {
    const { CompanyName } = this.state
    sessionStorage.setItem("ExhRegistrationIDSS", exhRegId)
    if (ServiceID == 3) {
      this.props.navigate('/powerConnection', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 4) {
      this.props.navigate('/water', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 5) {
      this.props.navigate('/airConnectionApplication', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 6) {
      this.props.navigate('/meetingRoomRequestForm', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 9) {
      this.props.navigate('/exhibitorbadgeAU', { state: { is_View: true, from: 'vendor' } })
    } else if (ServiceID == 10) {
      this.props.navigate('/stallDesign', { state: { is_View: true, from: 'vendor' } })
    }
    else if (ServiceID == 21) {
      this.props.navigate('/freightForward', { state: { is_View: true, from: 'vendor' } })
    }
  }

  openRaiseModal = (record) => {
    const documentFile = record.InvoiceDocument
      ? { FileName: record.InvoiceDocument.split('/').pop(), FilePath: `${DOC_BASE_URL}${record.InvoiceDocument}`, FileType: '' }
      : { FileName: '', FilePath: '', FileType: '' };

    this.setState({
      showRaiseModal: true,
      selectedRecord: record,
      selectedFile: null,
      useCamera: false,
      documentFile
    })
  }

  openMarkPaidModal = (record) => {
    this.setState({ showMarkPaidModal: true, selectedRecord: record })
  }

  closeModals = () => {
    this.setState({
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: '', FilePath: '', FileType: '' },
      showCameraModal: false
    })
  }

  handleFileSelect = (e) => {
    this.setState({ selectedFile: e.target.files[0] })
  }

  async handleDocumentInput(e, fieldName) {
    if (fieldName === 'file') {
      const result = await this.onFilePick(e, e.target.files)
      if (result) {
        this.setState({
          documentFile: {
            FilePath: result.FilePath,
            FileName: result.FileName,
            FileType: result.FileType
          }
        })
      }
    } else if (fieldName === 'clear') {
      this.setState({
        documentFile: { FileName: '', FilePath: '', FileType: '' }
      })
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault()
    var image = '';
    if (file[0]['size'] > 3145728) {
      toast.error('File size more than 3MB are not allow.', {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      })
      return null;
    } else {
      if (file[0]['name'].toString().toLowerCase().includes('.pdf')
        ||
        file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
        file[0]['name'].toString().toLowerCase().includes('.png') ||
        file[0]['name'].toString().toLowerCase().includes('.jpg')
      ) {
        if (file[0]['name'].includes('pdf')) {
          image = await this.onPdfSelect(file[0]);
        }
        else {
          image = await this.resizeFile(file[0]);
        }

        const fileType = file[0]['type']
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/")
        }
        const finalFileTypeName = fileTypeList.length > 0 ? fileTypeList[1] : ''

        return { FilePath: image, FileName: file[0]['name'], FileType: finalFileTypeName }

      } else {
        toast.error('Only .pdf, .jpeg, .png, files are allowed', {
          position: "top-center",
          theme: 'colored',
          autoClose: 3000,
          hideProgressBar: true,
        })
        return null;
      }
    }
  }

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        resolve(base64);
      };
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });



  handleViewFile = (filePathOrBase64, fileName) => {
    // Check if it's a base64 string or a URL
    if (filePathOrBase64.startsWith('data:')) {
      // Handle base64 string
      const mimeType = filePathOrBase64.split(';')[0].split(':')[1];
      const byteCharacters = atob(filePathOrBase64.split(',')[1]);
      const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const fileURL = URL.createObjectURL(blob);

      if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
        window.open(fileURL, '_blank', 'noopener,noreferrer');
      } else {
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = fileName;
        link.click();
      }
      setTimeout(() => URL.revokeObjectURL(fileURL), 500);
    } else {
      // Handle regular URL
      window.open(filePathOrBase64, '_blank', 'noopener,noreferrer');
    }
  };

  handleCameraCapture = async (base64Image) => {
    this.setState({
      documentFile: {
        FilePath: base64Image,
        FileName: 'camera-capture.jpg',
        FileType: 'jpeg'
      },
      showCameraModal: false,
      showRaiseModal: true
    })
  }

  handleRaiseManualForm = () => {
    const { selectedRecord, documentFile } = this.state

    if (!documentFile.FilePath || documentFile.FilePath.trim() === '') {
      toastError('Please upload a file')
      return
    }

    const documentData = [{
      DocumentName: documentFile.FileName,
      FileName: documentFile.FileName,
      FilePath: documentFile.FilePath,
      FileType: documentFile.FileType,
      ActionID: 1
    }]

    this.setState({ isLoading: true })
    this.props.raiseManualForm_action(selectedRecord.ManualFormID, selectedRecord.RecordID, documentData)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess('Manual form raised successfully!')
          this.closeModals()
          this.getVendorExhibitionList()
        } else {
          toastError(data.msg)
        }
        this.setState({ isLoading: false })
      })
      .catch((err) => {
        toastError('Something went wrong!')
        this.setState({ isLoading: false })
      })
  }

  handleMarkPaid = () => {
    const { selectedRecord } = this.state
    const isPaid = selectedRecord?.IsInvoicePaid === true || selectedRecord?.IsInvoicePaid === 1
    const newPaidStatus = !isPaid

    this.setState({ isLoading: true })
    this.props.markManualFormInvoicePaid_action(selectedRecord.ManualFormID, selectedRecord.RecordID, newPaidStatus)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(newPaidStatus ? 'Manual form marked as paid successfully!' : 'Manual form unmarked as paid successfully!')
          this.closeModals()
          this.getVendorExhibitionList()
        } else {
          toastError(data.msg)
        }
        this.setState({ isLoading: false })
      })
      .catch((err) => {
        toastError('Something went wrong!')
        this.setState({ isLoading: false })
      })
  }

  // Single source of truth for the Action column - both the column header and the row icons are
  // built from this list, so adding an action here is enough to get it into the header as well
  getRowActions() {
    const isRoleID20 = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20
    const canRaiseBill = (data) => !isRoleID20 && data.isITMEBilling === false && data.optionForBillRaised === true

    return [
      {
        label: "View Details",
        iconClass: "fa fa-eye",
        color: "#17a2b8",
        isVisible: (data) => true,
        onClick: (data) => this.handleCompanyModal(data),
      },
      {
        label: "Upload Invoice",
        iconClass: "fa fa-file-text",
        color: "#007bff",
        isVisible: canRaiseBill,
        onClick: (data) => this.openRaiseModal(data),
      },
      {
        label: "Mark Invoice Paid",
        iconClass: "fa fa-check-circle",
        color: "#28a745",
        isVisible: canRaiseBill,
        onClick: (data) => this.openMarkPaidModal(data),
      },
    ]
  }

  render() {
    const { isLoading, ExhibitionID, CompanyName, vendorServiceList, PersonName, ServiceID, currentPage, vendorRegistrationList, exhibitionList, serviceTypeList, orderStatusList, dashboardData } = this.state

    const serviceList = dashboardData?.serviceList || [];
    const hasOnlyService32 = serviceList.length === 1 && serviceList[0]?.ServiceID === 32;

    console.log('serviceList:', serviceList, 'hasOnlyService32:', hasOnlyService32);

    if (hasOnlyService32) {
      return (
        <>
          <ToastContainer />
          {JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
            <ExhibitorHeader /> : <HeaderWithLogo />
          }
          <div class="main-content vendor-top-space">
            {JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
              <ExhibitorDrawer /> :
              JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17 ?
                <VendorDrawer /> : <AdminDrawer />
            }
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
              <div className="text-center">
                <h4>This page is not applicable for you</h4>
              </div>
            </div>
          </div>
        </>
      );
    }

    // console.log(vendorServiceList)
    var vendorServiceListArr = []
    vendorServiceList.length > 0 && vendorServiceList.forEach(item => {
      for (var i = 0; i < serviceTypeList.length; i++) {
        if (serviceTypeList[i].ServiceID == item.ServiceID) {
          vendorServiceListArr.push(serviceTypeList[i])
          break
        }
      }
    })
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage)

    // Action column header is built from the tooltips of the action icons this user can actually see
    const rowActions = this.getRowActions()
    const visibleActions = rowActions.filter((action) =>
      currentRecords.some((data) => action.isVisible(data))
    )
    const actionHeader = visibleActions.length > 0
      ? visibleActions.map((action) => action.label).join("/")
      : "Action"

    console.log("currentRecords", currentRecords)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) &&
          this.state.showVideoModal && (
            <div
              className="modal show d-block"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => this.setState({ showVideoModal: false })}
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Order</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ showVideoModal: false })}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <video controls autoPlay style={{ width: "100%" }}>
                      <source src="/assets/VendorOrder.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div class={"main-content vendor-top-space"}>
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20 &&
            <>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                <ExhibitorDrawer />
              ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17 ? (
                <VendorDrawer />
              ) : (
                <AdminDrawer />
              )}
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                <ExhibitorTopMenu />
              ) : null}

            </>
          }
          {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) && (
            <div className="d-flex justify-content-end px-2 pt-3 text-aqua">
              {/* <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{
                  cursor: "pointer",
                  color: "#3dbca7",
                  fontSize: "16px",
                  marginLeft: "auto",
                }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span> */}
            </div>
          )}
          {/* <div class="row">
                        <div class="step-name">
                            <p>Service Partner Registration List</p>
                        </div>
                    </div> */}
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20 && <div className="pt-3"></div>}
          <div class="row m-0 align-items-end">
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Exhibition</label>
              <select
                className="form-control"
                id="roledb"
                value={ExhibitionID}
                onChange={(e) => this.setState({ ExhibitionID: e.target.value })}
                disabled={JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17}
              >
                <option>Select</option>
                {exhibitionList.length > 0 &&
                  exhibitionList.map((data) => (
                    <option key={data.ExhibitionID} value={data.ExhibitionID}>
                      {data.ExhibitionName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Service Type</label>
              <select
                className="form-control"
                id="roledb"
                // style={{ textAlign: "left" }}
                value={ServiceID}
                onChange={(e) => this.setState({ ServiceID: e.target.value })}
              >
                <option>Select</option>
                {vendorServiceListArr.length > 0 &&
                  vendorServiceListArr.map((data) => (
                    <option key={data.ServiceID} value={data.ServiceID}>
                      {data.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Status</label>
              <select
                className="form-control"
                id="roledb"
                value={this.state.StatusID}
                onChange={(e) => this.setState({ StatusID: e.target.value })}
              >
                <option>Select</option>
                {orderStatusList.length > 0 &&
                  orderStatusList.map((data) => (
                    <option key={data.Code} value={data.Code}>
                      {data.Description}
                    </option>
                  ))}
              </select>
            </div>
            {/* <div className="row mt-3"> */}
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3 d-flex justify-content-start justify-content-lg-end">
              <div
                className=" mb-1"
                role="group"
                aria-label="Basic example"
                style={{ float: "left" }}
              >
                <button
                  type="button"
                  className="btn btn-aqua mx-2"
                  onClick={(e) => this.getVendorExhibitionList()}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-gray mx-2"
                  onClick={(e) => this.clearValue()}
                >
                  Clear
                </button>
              </div>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20
                && <>
                  {currentRecords.some(
                    (data) => data.isITMEBilling === false && data.optionForBillRaised === true
                  ) && (
                      <div className="d-flex flex-column ms-3" style={{ fontSize: "13px" }}>
                        <span className="mb-1">
                          <i
                            className="fa fa-file-text"
                            style={{ color: "#007bff", marginRight: "5px" }}
                          ></i>
                          <span className="me-1">Upload Invoice</span>
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#6c757d", cursor: "pointer" }}
                            title="Upload invoice document directly to exhibitor"
                          ></i>
                        </span>
                        <span>
                          <i
                            className="fa fa-check-circle"
                            style={{ color: "#28a745", marginRight: "5px" }}
                          ></i>
                          <span className="me-1">Mark Payment</span>
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#6c757d", cursor: "pointer" }}
                            title="Mark the invoice as paid after payment confirmation"
                          ></i>
                        </span>
                      </div>
                    )}
                </>
              }
            </div>
            {/* </div> */}
          </div>

          <div class="table-responsive mb-5 p-2">
            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-2">
              <thead className="table-light">
                <tr>
                  {/* Hall */}
                  <th className="text-center">
                    <div className="th-header-with-sort">
                      <span>Hall</span>
                      {/* <div className="icons-shorting"
                          onClick={() => this.handleSort("Hall")}
                        >
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Zone */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Zone</span>
                      {/* <div className="icons-shorting"
                          onClick={() => this.handleSort("Zone")}
                        >
                          <i className="" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Stall */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Stall</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Stall")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Exhibitor */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Exhibitor</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Exhibitor")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>
                  <th>
                    <div className="th-header-with-sort">
                      <span>Form Submit Date</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Exhibitor")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Service */}
                  <th>
                    <div className="th-header-with-sort">
                      <span>Service</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("Service")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  <th>
                    <div className="th-header-with-sort">
                      <span>Country</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("ScheduledDate")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>
                  {/* <th>
                    <div className="th-header-with-sort">
                      <span>GST No</span>
                    </div>
                  </th>
                  <th>
                    <div className="th-header-with-sort">
                      <span>PAN No</span>
                    </div>
                  </th> */}
                  <th>{false ? "Work Status" : "Status"}</th>

                  <th style={{ width: '100px', textAlign: 'center' }}>
                    <div className="th-header-with-sort justify-content-center">
                      <span>{actionHeader}</span>
                      {/* <div className="icons-shorting" onClick={() => this.handleSort("ScheduledDate")}>
                          <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ cursor: "pointer", marginLeft: 3 }}
                          ></i>
                        </div> */}
                    </div>
                  </th>

                  {/* Status / Work Status */}
                </tr>
              </thead>
              <tbody>
                {currentRecords?.length > 0 ? (
                  (currentRecords
                  ).map((item, i) =>
                    <tr>
                      <td className="text-left hall-name">{item.Hall}</td>
                      <td>{item.Zone}</td>
                      <td>{item.Stall}</td>
                      <td>
                        <div className="text-nowrap">
                          <div style={{ fontWeight: 650, marginBottom: '6px' }}>{item.ExhRegistrationNo}</div>
                          
                          <div className="d-flex align-items-center gap-3">
                            <span>
                              <i className="fa fa-building-o grid-icon me-1"></i>
                              <span className="text-aqua"
                                onClick={(e) => this.handleCompanyModal(item)}
                                style={{ cursor: "pointer" }}>
                                {item.CompanyName != null ? item.CompanyName : "-"}
                              </span>
                            </span>
                            
                            <span>
                              <i className="ri-user-3-line grid-icon me-1"></i>
                              {item.name != null ? item.name : "-"}
                            </span>
                            
                            <span>
                              <i className="ri-mail-line grid-icon me-1"></i>
                              {item.Email}
                            </span>
                          </div>
                        </div>
                      </td>
                      {/* <td>/td> */}
                      <td>
                        {item.ExhRegistrationDate != null
                          ? moment(item.ExhRegistrationDate).format("DD/MM/YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item.serviceprovided || "-"}{" "}
                        {item.serviceprovided != 'NA' &&
                          <span
                            style={{ cursor: "pointer", fontSize: "18px", paddingTop: "30px" }}
                            onClick={() =>
                              this.handleManualFormModal(item.serviceprovided, item.ExhRegistrationID)
                            }
                          >
                            <i
                              class="bi bi-info-circle"
                              style={{ transition: "color 0.2s" }}
                              onMouseEnter={(e) => (e.target.style.color = "blue")}
                              onMouseLeave={(e) => (e.target.style.color = "")}
                            ></i>
                          </span>
                        }
                      </td>
                      <td>{item.CountryName}</td>
                      {/* <td>{item.GSTNo}</td>
                      <td>{item.PanNo}</td> */}
                      <td>
                        <span
                          // style={{
                          //   color: !item.WorkStatusID ? "" : "",
                          // }}
                          className={item.WorkStatusID ? "status text-aqua" : "status grid-icon"}
                        >
                          {item.Status}
                        </span>
                      </td>
                      <td className="text-center">
                        <i
                          className="fa fa-eye"
                          aria-hidden="true"
                          style={{
                            marginRight: "12px",
                            cursor: "pointer",
                            color: "#17a2b8",
                          }}
                          title="View Details"
                          onClick={() => this.handleCompanyModal(item)}
                        />
                        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 20 && item.isITMEBilling === false && item.optionForBillRaised === true && (
                          <>
                            <i
                              className="fa fa-file-text"
                              aria-hidden="true"
                              style={{
                                marginRight: "12px",
                                cursor: "pointer",
                                color: "#007bff",
                              }}
                              title={item.InvoiceDocument ? "Upload/Change Invoice" : "Upload Invoice"}
                              onClick={() => this.openRaiseModal(item)}
                            />
                            {!(item.IsInvoicePaid === true || item.IsInvoicePaid === 1) && (
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                                style={{ cursor: "pointer", color: "#28a745" }}
                                title="Mark Invoice Paid"
                                onClick={() => this.openMarkPaidModal(item)}
                              />
                            )}
                            {(item.IsInvoicePaid === true || item.IsInvoicePaid === 1) && (
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                                style={{ cursor: "pointer", color: "#28a745", opacity: 0.5 }}
                                title="Invoice Marked as Paid"
                              />
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                  )
                ) : (
                  <tr>
                    <td colSpan={20} className="text-center">
                      Record not found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="m-2 float-left trp">
            {vendorRegistrationList.length > 0 ? (
              <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={this.updateItem}
              />
            ) : (
              <></>
            )}
            <div className="table-record-pages">
              <p>{`${currentPage} of ${nPages} pages`}</p>
            </div>
          </div>
        </div>

        {/* Raise Manual Form Modal */}
        {this.state.showRaiseModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload Invoice</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {this.state.selectedRecord?.InvoiceDocument && (this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1) ? (
                      <div className="mb-3">
                        <div className="d-flex align-items-center">
                          <span
                            className="text-primary me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.handleViewFile(
                                this.state.documentFile.FilePath,
                                this.state.documentFile.FileName
                              )
                            }
                          >
                            <i className="fa fa-eye me-1"></i>
                            {this.state.documentFile.FileName}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3">
                        {this.state.documentFile.FilePath ? (
                          <div className="d-flex align-items-center">
                            <span
                              className="text-primary me-2"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.handleViewFile(
                                  this.state.documentFile.FilePath,
                                  this.state.documentFile.FileName
                                )
                              }
                            >
                              <i className="fa fa-eye me-1"></i>
                              {this.state.documentFile.FileName}
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => this.handleDocumentInput(null, "clear")}
                            >
                              <i className="fa fa-times"></i> Remove
                            </button>
                          </div>
                        ) : (
                          <>
                            <label className="form-label">Upload Invoice Document</label>
                            <input
                              type="file"
                              className="form-control mb-2"
                              accept="image/*,application/pdf"
                              onChange={(e) => this.handleDocumentInput(e, "file")}
                            />
                            <div className="text-center">
                              <span className="text-muted">OR</span>
                            </div>
                            <button
                              type="button"
                              className="btn btn-aqua w-100 mt-2"
                              onClick={() =>
                                this.setState({ showCameraModal: true, showRaiseModal: false })
                              }
                            >
                              <i className="fa fa-camera me-2"></i>
                              Capture from Camera
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    <div className="alert alert-warning d-flex align-items-center py-2 mb-2">
                      <i className="fa fa-exclamation-triangle me-2"></i>
                      <small>
                        All transactions will be between you and the exhibitor only. The
                        organizer is not involved.
                      </small>
                    </div>
                    <div className="text-center">
                      <small className="text-muted">
                        Supported formats: PDF, JPEG, PNG, JPG (Max size: 5MB)
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-gray" onClick={this.closeModals}>
                      Back
                    </button>
                    {!(this.state.selectedRecord?.InvoiceDocument && (this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1)) && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleRaiseManualForm}
                      >
                        Yes, Upload direct to exhibitor
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}

        {/* Camera Capture Modal */}
        <ImageCapture
          isOpen={this.state.showCameraModal}
          onClose={() => this.setState({ showCameraModal: false, showRaiseModal: true })}
          onCapture={this.handleCameraCapture}
          label="Capture Invoice Document"
        />

        {/* Mark Manual Form Invoice Paid Modal */}
        {this.state.showMarkPaidModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title text-aqua">
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Confirm Unmark Payment'
                        : 'Confirm Payment'}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Are you sure you want to unmark this manual form invoice as paid?'
                        : 'Are you sure you want to mark this manual form invoice as paid?'}
                    </p>
                    {this.state.selectedRecord && (
                      <div className="">
                        <strong>Company:</strong> {this.state.selectedRecord.CompanyName}
                        <br />
                        <strong>Service:</strong> {this.state.selectedRecord.serviceprovidedDisplayName}
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-gray py-1"
                      onClick={this.closeModals}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleMarkPaid}
                    >
                      {this.state.selectedRecord?.IsInvoicePaid === true || this.state.selectedRecord?.IsInvoicePaid === 1
                        ? 'Yes, Unmark as Paid'
                        : 'Yes, Mark as Paid'}
                    </button>
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}
        <Modal
          isOpen={this.state.isManualFormModalOpen}
          onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header  text-white">
                <h6 className="modal-title">Manual Form</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isManualFormModalOpen: false })}
                />
              </div>

              <div className="modal-body">{this.openModal(this.state.selectedServiceName)}</div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isManualFormModalOpen: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isCompanyModalOpen}
          onRequestClose={() => this.setState({ isCompanyModalOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-almost-fullscreen">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h6 className="modal-title">Order Details</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isCompanyModalOpen: false })}
                />
              </div>

              <div className="modal-body">
                {this.state.selectedCompanyData && this.openModal(this.state.selectedCompanyData.serviceprovided)}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isCompanyModalOpen: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(connect(null, { fill_action, getVendorExhibitionList_action, markOrderSeen_action, raiseManualForm_action, markManualFormInvoicePaid_action })(VendorExhibitionList));

